import { useTranslation } from 'react-i18next';

import { abbrNumber } from '@hotjar/insights-common/lib/number';
import { capitalize } from '@hotjar/insights-common/lib/string';

import { HEATMAP_DATA_TYPES } from '../../constants-types/HeatmapDataTypes';
import { HEATMAP_DEVICE_TYPES } from '../../constants-types/HeatmapDeviceTypes';
import { SmartPanelSegmentColumn } from './SmartPanelBlocks';
import { SmartPanelSpacedText } from './SmartPanelSpacedText';
import { TopClicksWidget } from './TopClicksWidget';

import type { TrackableSite } from '../../constants-types/ExternalDependencyTypes';

export function TotalClicksSegment({
  currentSite,
  device,
  value,
  heatType,
  isTopClicksWidgetActive,
  onTopClicksWidgetToggle,
  shouldHideTopClicksWidget,
}: {
  currentSite?: TrackableSite;
  device: HeatmapDeviceTypes;
  value?: number;
  heatType: HeatmapDataType;
  isTopClicksWidgetActive: boolean;
  onTopClicksWidgetToggle: (isActive: boolean) => void;
  shouldHideTopClicksWidget?: boolean;
}): JSX.Element | null {
  const { t } = useTranslation('heatmaps');

  if (heatType !== HEATMAP_DATA_TYPES.CLICK) return null;

  const clicksOrTaps =
    device === HEATMAP_DEVICE_TYPES.DESKTOP ? t('general-terms.clicks') : t('general-terms.taps');

  const countText = value !== undefined ? `${abbrNumber(value)}` : '-';
  const clicksText = `${capitalize(t('general-terms.total'))} ${clicksOrTaps}`;

  return (
    <SmartPanelSegmentColumn>
      <SmartPanelSpacedText leftText={clicksText} rightText={countText} />
      {!(shouldHideTopClicksWidget ?? false) && (
        <TopClicksWidget
          currentSite={currentSite}
          device={device}
          isTopClicksWidgetActive={isTopClicksWidgetActive}
          onTopClicksWidgetToggle={onTopClicksWidgetToggle}
        />
      )}
    </SmartPanelSegmentColumn>
  );
}
